import { render, staticRenderFns } from "./reservationDetailModal.vue?vue&type=template&id=ed28c6b6&scoped=true&"
import script from "./reservationDetailModal.vue?vue&type=script&lang=ts&"
export * from "./reservationDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./reservationDetailModal.vue?vue&type=style&index=0&id=ed28c6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed28c6b6",
  null
  
)

export default component.exports